import { SetupAssistantForm } from '@pages/project/activities/setupAssistant/setupAssistant.types';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@app/hooks';
import { useHandleActivityState } from '@pages/activityBuilder/hooks/useHandleActivityState';
import { selectCurrentProject } from '@features/project/projectSlice';
import { useModulesInput } from '@pages/project/activities/setupAssistant/hooks/useModulesInput';
import { useSetupAssistantFinish } from '@pages/project/activities/setupAssistant/hooks/useSetupAssistantFinish';
import { FinalForm } from '@pages/project/activities/setupAssistant/SetupAssistantFinish';

const initValues: FinalForm = {
  modulesList: [],
  area: undefined,
  landUse_start: undefined,
  landUse_w: undefined,
  landUse_wo: undefined,
};


export const useEditModules = ({ setIsSuccessModalOpen }: { setIsSuccessModalOpen: (isOpen: boolean) => void }) => {
  const [values, setValues] = useState<SetupAssistantForm>({})
  const { activity } = useHandleActivityState();
  const { project } = useAppSelector(selectCurrentProject)

  const editModulesProps = useSetupAssistantFinish([], values, () => {
    setIsSuccessModalOpen(true);
  });

  const modulesInput = useModulesInput();
  const initialValues: FinalForm = {
    ...initValues,
    modulesList: [...editModulesProps.preSelected],
    area: editModulesProps.area,
    ...editModulesProps.lucs
  };

  useEffect(() => {
    if (activity)
      setValues({
        activityTitle: activity.name,
        changeRate: activity.change_rate?.id,
        climate: activity.climate_t2?.id ?? project?.climate?.id,
        moisture: activity.moisture_t2?.id ?? project?.moisture?.id,
        startYear: activity.start_year_t2 ?? project?.start_year_of_activities,
        duration: activity.duration_t2 ?? project?.implementation_years,
        activityCost: activity.cost ?? undefined,
      })
  }, [activity])

  return {
    editModulesProps,
    modulesInput,
    initialValues,
    values
  }
}